import { Injectable } from '@angular/core';
import { setProps } from '@ngneat/elf';
import { Observable } from 'rxjs';

import { MaintenanceStatus } from '~shared/types/maintenance.types';

import { maintenanceStore } from './maintenance.store';
import { maintenanceSelector } from './maintenance.selectors';

@Injectable({ providedIn: 'root' })
export class MaintenanceRepository {
	public status$: Observable<MaintenanceStatus> = maintenanceSelector.status$;
	public isInMaintenance$: Observable<boolean> = maintenanceSelector.isInMaintenance$;

	public setStatus(status: MaintenanceStatus): void {
		maintenanceStore.update(setProps(status));
	}

	public isInMaintenance(): boolean {
		return maintenanceStore.query((state) => state.enabled);
	}
}